import React, { ReactElement, useState } from 'react';
import { ImageCustom } from '../../../../common/components/ImageCustom';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import { BiComment } from 'react-icons/bi';
// import { IoShareOutline } from 'react-icons/io5';
import { BsThreeDots } from 'react-icons/bs';
import './TimelinePostItem.scss';
import { ResponsePostTimeline } from '../../../../services/api/models/response/responseTimeline';
import { formatDateForPost } from '../../../../common/utils/utils';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../store/store';
import {
  useDisLikeMutation,
  useSendLikePostMutation,
} from '../../../../services/api/apiProvider';
import TimelineDetailModal from '../TimelineModal/TimelineDetailModal';

export interface PostItemProps {
  post: ResponsePostTimeline;
}

const TimelinePostItem = (props: PostItemProps): ReactElement => {
  const { post } = props;
  const [isLike, setIsLike] = useState<boolean>(post.niceStatus === 'nice');
  const [numberLike, setNumberLike] = useState<number>(post.numberOfNice);
  const { currentUser } = useSelector(
    (state: AppState) => state.profilePageState,
  );
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [sendLike] = useSendLikePostMutation();
  const [disLike] = useDisLikeMutation();

  const handleSendLike = async () => {
    if (currentUser?.id === post.user.id) {
      return;
    }
    if (!isLike) {
      await sendLike(post.id).unwrap();
      setIsLike(!isLike);
      setNumberLike(numberLike + 1);
    } else {
      await disLike(post.id).unwrap();
      setIsLike(!isLike);
      setNumberLike(numberLike - 1);
    }
  };

  const handleShowDetailPost = async () => {
    setIsShowModal(true);
  };
  const handleCloseDetailPostModal = (child: boolean) => {
    setIsShowModal(child);
  };

  return (
    <div className="timeline-post-item">
      <div className="timeline-post-item__user">
        <div className="timeline__avatar">
          <ImageCustom src={post.user.picture.uri} />
        </div>
        <div className="timeline-post-item__info">
          <div className="timeline-post-item__user-name">
            {post.user.loginId}
          </div>
          <div className="timeline-post-item__time-post">
            {formatDateForPost(post.postDateTime)}
          </div>
        </div>
      </div>
      <div onClick={handleShowDetailPost} className="timeline-post-item__image">
        <ImageCustom src={post.media.uri} />
      </div>
      <div className="timeline-post-item__description">{post.message}</div>
      <div className="timeline-post-item__footer">
        <div className="timeline-post-item__footer-left">
          <div onClick={handleSendLike} className="timeline-post-item__icon">
            {isLike ? (
              <AiFillHeart style={{ color: 'red' }} />
            ) : (
              <AiOutlineHeart />
            )}
            <span className="timeline-post-item__count">{numberLike}</span>
          </div>
          <div
            onClick={handleShowDetailPost}
            className="timeline-post-item__icon"
          >
            <BiComment />
            <span className="timeline-post-item__count">
              {post.numberOfComments}
            </span>
          </div>
          {/* <div className="timeline-post-item__icon">
            <IoShareOutline />
          </div> */}
        </div>
        {/* {currentUser?.id === post.user.id && (
          <div className="timeline-post-item__icon">
            <BsThreeDots />
          </div>
        )} */}
      </div>
      <TimelineDetailModal
        post={post}
        isShow={isShowModal}
        callBackClose={handleCloseDetailPostModal}
      />
    </div>
  );
};
export default TimelinePostItem;
